import { UntypedFormControl } from "@angular/forms";
import { Component, EventEmitter, Input, Output, OnInit, ViewChild } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { debounceTime } from "rxjs/operators";

import { IAutoCompleteSearchProvider } from "../../models/domains/auto-complete/iauto-complete-search-provider";
import { IAutoCompleteItem } from "../../models/domains/auto-complete/iauto-complete-item";

@Component({
  selector: "auto-complete-search",
  templateUrl: "./auto-complete-search.component.html",
  styleUrls: ["./auto-complete-search.component.scss"],
})
export class AutoCompleteSearchComponent implements OnInit {
  @Output() valueChange = new EventEmitter<IAutoCompleteItem>();
  @Input() width: number;
  @Input() value: any;
  @Input() searchProvider: IAutoCompleteSearchProvider;
  @Input() placeholder = "";
  @Input() appearance = "";
  @Input() initFocused = false;

  @ViewChild("input") input: HTMLInputElement;

  searchControl: UntypedFormControl = new UntypedFormControl();
  filteredOptions: BehaviorSubject<any[]> = new BehaviorSubject(undefined);

  constructor() {
    this.searchControl.valueChanges.pipe(debounceTime(400)).subscribe((data) => {
      if (typeof data === "string") {
        this.filter(data);
      }
    });
  }

  ngOnInit() {
    this.searchControl.setValue(this.value ? this.value : "");
    document.addEventListener("resetSearchControl", () => {
      this.searchControl.reset();
    });
  }

  private async filter(filterByText: string) {
    const items = await this.searchProvider.search(filterByText);
    this.filteredOptions.next(items);
  }

  public getDisplayFn() {
    return (val: any) => this.display(val);
  }

  private display(item: IAutoCompleteItem): string {
    if (typeof item === "string") {
      return item;
    }
    return item ? item.getDisplayValue() : "";
  }

  public selected(item: IAutoCompleteItem) {
    this.value = item.getDisplayValue();
    this.valueChange.emit(item);
  }

  public onFocusInput(): void {
    if (document.getElementById("inputFilterText")) {
      document.getElementById("inputFilterText").click();
    }
  }
}
